import * as invoiceActions from './invoicesActions';
import * as invoiceListDownloadActions from './invoicesListActions';

const Actions = {
  ...invoiceActions,
  ...invoiceListDownloadActions,
};

export default Actions;
